import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _59a82648 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "" */))
const _3fcbed9c = () => interopDefault(import('../../../pages/about_us.vue' /* webpackChunkName: "" */))
const _4de52dc4 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "" */))
const _3428f3a2 = () => interopDefault(import('../../../pages/news/index.vue' /* webpackChunkName: "" */))
const _84003820 = () => interopDefault(import('../../../pages/renting/index.vue' /* webpackChunkName: "" */))
const _4c04a077 = () => interopDefault(import('../../../pages/selling/index.vue' /* webpackChunkName: "" */))
const _ee741f20 = () => interopDefault(import('../../../pages/news/_category/index.vue' /* webpackChunkName: "" */))
const _045f573e = () => interopDefault(import('../../../pages/renting/_category/index.vue' /* webpackChunkName: "" */))
const _55435705 = () => interopDefault(import('../../../pages/selling/_category/index.vue' /* webpackChunkName: "" */))
const _f1e161b0 = () => interopDefault(import('../../../pages/news/_category/_slug.vue' /* webpackChunkName: "" */))
const _02a8b5f6 = () => interopDefault(import('../../../pages/renting/_category/_slug.vue' /* webpackChunkName: "" */))
const _538cb5bd = () => interopDefault(import('../../../pages/selling/_category/_slug.vue' /* webpackChunkName: "" */))
const _48cc4714 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "" */))
const _445b2112 = () => interopDefault(import('../../../pages/_page.vue' /* webpackChunkName: "" */))
const _705a2dce = () => interopDefault(import('../../../pages/*.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active-link',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _59a82648,
    name: "404-fr"
  }, {
    path: "/en/404",
    component: _59a82648,
    name: "404-en"
  }, {
    path: "/lagence",
    component: _3fcbed9c,
    name: "about_us-fr"
  }, {
    path: "/en/lagence",
    component: _3fcbed9c,
    name: "about_us-en"
  }, {
    path: "/contact",
    component: _4de52dc4,
    name: "contact-fr"
  }, {
    path: "/en/contact",
    component: _4de52dc4,
    name: "contact-en"
  }, {
    path: "/actualite",
    component: _3428f3a2,
    name: "news-fr"
  }, {
    path: "/en/news",
    component: _3428f3a2,
    name: "news-en"
  }, {
    path: "/location",
    component: _84003820,
    name: "renting-fr"
  }, {
    path: "/en/renting",
    component: _84003820,
    name: "renting-en"
  }, {
    path: "/vente",
    component: _4c04a077,
    name: "selling-fr"
  }, {
    path: "/en/selling",
    component: _4c04a077,
    name: "selling-en"
  }, {
    path: "/actualite/:category",
    component: _ee741f20,
    name: "news-category-fr"
  }, {
    path: "/en/news/:category",
    component: _ee741f20,
    name: "news-category-en"
  }, {
    path: "/location/:category",
    component: _045f573e,
    name: "renting-category-fr"
  }, {
    path: "/en/renting/:category",
    component: _045f573e,
    name: "renting-category-en"
  }, {
    path: "/vente/:category",
    component: _55435705,
    name: "selling-category-fr"
  }, {
    path: "/en/selling/:category",
    component: _55435705,
    name: "selling-category-en"
  }, {
    path: "/actualite/:category/:slug",
    component: _f1e161b0,
    name: "news-category-slug-fr"
  }, {
    path: "/en/news/:category/:slug",
    component: _f1e161b0,
    name: "news-category-slug-en"
  }, {
    path: "/location/:category/:slug",
    component: _02a8b5f6,
    name: "renting-category-slug-fr"
  }, {
    path: "/en/renting/:category/:slug",
    component: _02a8b5f6,
    name: "renting-category-slug-en"
  }, {
    path: "/vente/:category/:slug",
    component: _538cb5bd,
    name: "selling-category-slug-fr"
  }, {
    path: "/en/selling/:category/:slug",
    component: _538cb5bd,
    name: "selling-category-slug-en"
  }, {
    path: "/",
    component: _48cc4714,
    name: "index-fr"
  }, {
    path: "/en/",
    component: _48cc4714,
    name: "index-en"
  }, {
    path: "/:page",
    component: _445b2112,
    name: "page-fr"
  }, {
    path: "/en/:page",
    component: _445b2112,
    name: "page-en"
  }, {
    path: "/*",
    component: _705a2dce,
    name: "*-fr"
  }, {
    path: "/en/*",
    component: _705a2dce,
    name: "*-en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
